import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import TruncateText from './TruncateText';
import EmptyButton from './EmptyButton';

const defaultRender = ({ onClick, show }) => (
  <EmptyButton
    onClick={onClick}
    display="flex"
    alignItems="center"
    marginTop="10px"
  >
    See&nbsp;
    {show ? 'Less' : 'More'}
  </EmptyButton>
);

const TextReveal = ({ lines, renderShowMore, children, ...props }) => {
  const [show, setShow] = useState();
  const [elm, setElm] = useState();

  const isTruncated = useMemo(
    () => elm && elm.scrollHeight > elm.clientHeight,
    [elm]
  );

  const onClick = () => setShow(!show);

  return (
    <>
      <TruncateText
        ref={ref => setElm(ref)}
        lines={show ? 'unset' : lines}
        {...props}
      >
        {children}
      </TruncateText>
      {isTruncated && renderShowMore({ onClick, show })}
    </>
  );
};

TextReveal.propTypes = {
  lines: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  renderShowMore: PropTypes.func,
  children: PropTypes.node,
};

TextReveal.defaultProps = {
  lines: 3,
  renderShowMore: defaultRender,
  children: null,
};

export default TextReveal;
